import React from "react";
import "../styles/exam-screen.css";

/**
 * Full-viewport gate shown before/whenever the student is not in fullscreen during a
 * (non-DPP) genericV2 exam. Blocks interaction with the exam behind it until fullscreen
 * is granted via a real click (browsers require a user gesture for requestFullscreen).
 */
export default function SecureModeOverlay({ onEnterFullscreen }) {
    return (
        <div className="secure-mode-overlay">
            <div className="secure-mode-overlay-box">
                <i className="fas fa-lock secure-mode-overlay-icon" />
                <h2>Secure Exam Mode</h2>
                <p>
                    This exam must be taken in fullscreen. Click below to enter fullscreen and begin. Leaving
                    fullscreen, switching tabs, or trying to copy/inspect the page during the exam will be recorded
                    as a warning.
                </p>
                <button type="button" className="secure-mode-enter-btn" onClick={onEnterFullscreen}>
                    Enter Secure Exam Mode
                </button>
            </div>
        </div>
    );
}
